import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';
import { LoginComponent } from './core/login/login.component';
import { AuthGuard } from './auth/auth.guard';
import { PageNotfoundComponent } from './page-notfound/page-notfound.component';
import { HomeComponent } from './modules/exam-ui/home/home.component';
import { BlogsComponent } from './modules/exam-ui/blogs/blogs.component';
import { BlogDetailsComponent } from './modules/exam-ui/blog-details/blog-details.component';
import { ForumsComponent } from './modules/exam-ui/forums/forums.component';
import { UserDashboardComponent } from './modules/exam-ui/user-dashboard/user-dashboard.component';
import { FaqComponent } from './modules/exam-ui/faq/faq.component';
import { UserLoginComponent } from './modules/exam-ui/user-login/user-login.component';
import { ChapterQuestionsComponent } from './modules/exam-ui/chapter-questions/chapter-questions.component';
import { ClientLoginComponent } from './modules/exam-ui/login/login.component';
import { EventsComponent } from './modules/exam-ui/events/events.component';
import { EventDetailsComponent } from './modules/exam-ui/event-details/event-details.component';
import { SignUpComponent } from './modules/exam-ui/sign-up/sign-up.component';
import { ForumDetailsComponent } from './modules/exam-ui/forum-details/forum-details.component';
import { BookViewerComponent } from './modules/exam-ui/book-viewer/book-viewer.component';
import { AuthGuardAdmin } from './auth/auth.guardAdmin';
import { MoreInfoComponent } from './modules/exam-ui/more-info/more-info.component';
import { SignUpSimpleComponent } from './modules/exam-ui/sign-up-simple/sign-up-simple.component';
import { MindsetshiftComponent } from './modules/exam-ui/mindsetshift/mindsetshift.component';
import { PrivacyPolicyComponent } from './modules/exam-ui/policy-terms/privacy-policy/privacy-policy.component';
import { RefundPolicyComponent } from './modules/exam-ui/policy-terms/refund-policy/refund-policy.component';
import { CancellationPolicyComponent } from './modules/exam-ui/policy-terms/cancellation-policy/cancellation-policy.component';
import { TermsConditionsComponent } from './modules/exam-ui/policy-terms/terms-conditions/terms-conditions.component';
import { DisclosureComponent } from './modules/exam-ui/policy-terms/disclosure/disclosure.component';
import { DisclaimerComponent } from './modules/exam-ui/policy-terms/disclaimer/disclaimer.component';
import { ShippingDeliveryPolicyComponent } from './modules/exam-ui/policy-terms/shipping-delivery-policy/shipping-delivery-policy.component';
import { AboutComponent } from './modules/exam-ui/about/about.component';
import { ContactComponent } from './modules/exam-ui/contact/contact.component';
import { ForgotPasswordComponent } from './modules/exam-ui/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './modules/exam-ui/reset-password/reset-password.component';

const appRoutes: Route[] = [
  { path: 'admin/login', component: LoginComponent },
  { path: '404', component: PageNotfoundComponent },
  { path: 'home', component: HomeComponent },
  { path: 'more-info', component: MoreInfoComponent },
  { path: 'mindsetshift', component: MindsetshiftComponent},
  { path: 'blogs', component: BlogsComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'blog/:blogId', component: BlogDetailsComponent },
  { path: 'events', component: EventsComponent },
  { path: 'event/:eventId', component: EventDetailsComponent },
  { path: 'forums', component: ForumsComponent, canActivate: [AuthGuard] },
  { path: 'forums/:id', component: ForumDetailsComponent, canActivate: [AuthGuard] },
  { path: 'login', component: ClientLoginComponent },
  { path: 'activate-account/:guid', component: SignUpComponent },
  { path: 'activate/:guid', component: ClientLoginComponent },
  { path: 'signup', component: SignUpSimpleComponent},
  { path: 'user-dashboard', component: UserDashboardComponent, canActivate: [AuthGuard] },
  { path: 'faq', component: FaqComponent },
  { path: 'library', component: BookViewerComponent, canActivate: [AuthGuard] },
  { path: 'user-login', component: UserLoginComponent },
  { path: 'chapter-details/:chapterId', component: ChapterQuestionsComponent, canActivate: [AuthGuard] },
  { path: 'admin/v1', loadChildren: () => import('./modules/admin/views/view.module').then(m => m.ViewModule), canActivate: [AuthGuardAdmin] },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'refund-policy', component: RefundPolicyComponent },
  { path: 'cancellation-policy', component: CancellationPolicyComponent },
  { path: 'terms-conditions', component: TermsConditionsComponent },
  { path: 'disclosure', component: DisclosureComponent },
  { path: 'disclaimer', component: DisclaimerComponent },
  { path: 'shipping-delivery-policy', component: ShippingDeliveryPolicyComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password/:code', component: ResetPasswordComponent },
  { path: '**', redirectTo: 'home', pathMatch: 'full' }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes)
  ],
  exports: [RouterModule],
  declarations: []
})

export class AppRoutingModule { }
